export default {
  "code[class*=\"language-\"]": {
    "color": "#f8f8f2",
    "background": "none",
    "textShadow": "0 1px rgba(0, 0, 0, 0.3)",
    "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    "fontSize": "1em",
    "textAlign": "left",
    "whiteSpace": "pre",
    "wordSpacing": "normal",
    "wordBreak": "normal",
    "wordWrap": "normal",
    "lineHeight": "1.5",
    "MozTabSize": "4",
    "OTabSize": "4",
    "tabSize": "4",
    "WebkitHyphens": "none",
    "MozHyphens": "none",
    "msHyphens": "none",
    "hyphens": "none"
  },
  "pre[class*=\"language-\"]": {
    "color": "#f8f8f2",
    "background": "#272822",
    "textShadow": "0 1px rgba(0, 0, 0, 0.3)",
    "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    "fontSize": "1em",
    "textAlign": "left",
    "whiteSpace": "pre",
    "wordSpacing": "normal",
    "wordBreak": "normal",
    "wordWrap": "normal",
    "lineHeight": "1.5",
    "MozTabSize": "4",
    "OTabSize": "4",
    "tabSize": "4",
    "WebkitHyphens": "none",
    "MozHyphens": "none",
    "msHyphens": "none",
    "hyphens": "none",
    "padding": "1em",
    "margin": ".5em 0",
    "overflow": "auto",
    "borderRadius": "0.3em"
  },
  ":not(pre) > code[class*=\"language-\"]": {
    "background": "#272822",
    "padding": ".1em",
    "borderRadius": ".3em",
    "whiteSpace": "normal"
  },
  "comment": {
    "color": "#8292a2"
  },
  "prolog": {
    "color": "#8292a2"
  },
  "doctype": {
    "color": "#8292a2"
  },
  "cdata": {
    "color": "#8292a2"
  },
  "punctuation": {
    "color": "#f8f8f2"
  },
  "namespace": {
    "Opacity": ".7"
  },
  "property": {
    "color": "#f92672"
  },
  "tag": {
    "color": "#f92672"
  },
  "constant": {
    "color": "#f92672"
  },
  "symbol": {
    "color": "#f92672"
  },
  "deleted": {
    "color": "#f92672"
  },
  "boolean": {
    "color": "#ae81ff"
  },
  "number": {
    "color": "#ae81ff"
  },
  "selector": {
    "color": "#a6e22e"
  },
  "attr-name": {
    "color": "#a6e22e"
  },
  "string": {
    "color": "#a6e22e"
  },
  "char": {
    "color": "#a6e22e"
  },
  "builtin": {
    "color": "#a6e22e"
  },
  "inserted": {
    "color": "#a6e22e"
  },
  "operator": {
    "color": "#f8f8f2"
  },
  "entity": {
    "color": "#f8f8f2",
    "cursor": "help"
  },
  "url": {
    "color": "#f8f8f2"
  },
  ".language-css .token.string": {
    "color": "#f8f8f2"
  },
  ".style .token.string": {
    "color": "#f8f8f2"
  },
  "variable": {
    "color": "#f8f8f2"
  },
  "atrule": {
    "color": "#e6db74"
  },
  "attr-value": {
    "color": "#e6db74"
  },
  "function": {
    "color": "#e6db74"
  },
  "class-name": {
    "color": "#e6db74"
  },
  "keyword": {
    "color": "#66d9ef"
  },
  "regex": {
    "color": "#fd971f"
  },
  "important": {
    "color": "#fd971f",
    "fontWeight": "bold"
  },
  "bold": {
    "fontWeight": "bold"
  },
  "italic": {
    "fontStyle": "italic"
  }
};